module.exports = __webpack_public_path__ + "static/utomia-6fb8c60fafadbdb64bb8158bb43a50c3.png";